export enum ECookieKeys {
  AUTH_TOKEN = 'authenticationToken',
  EXTERNAL_REPORT_AUTH_TOKEN = 'externalReportAuthToken',
  EXTERNAL_REPORT_PAGE_TOKEN = 'externalReportPageToken',
  LOGIN_TYPE = 'loginType',
  REFRESH_KEY = 'refreshKey',
  SESSION_ID = 'sessionId',
  USER_ID = 'userId',
  USER_NAME = 'userName',
  USER_TYPE = 'userType',
  VALID_BEFORE = 'validBefore',
}
